<template lang="pug">
  .rating
    .rating__stars.rating-stars
      .rating-stars__img.rating-stars__img_bg
      .rating-stars__img.rating-stars__img_paint(
      :style="{ width: (value * 100 / 5) + '%' }"
      )
    .rating__number {{ value }}
</template>

<script>
export default {
  name: "Header",
  props: ["value"]
};
</script>
